import request from '@/utils/request'
import { getLegacyShapedCombos } from '@/services/combo/apis'
import { ExportComboRes, ExportLogReq, ImportLogReq } from '@/services/excel/excel.types'

export const callToGetExportCombo = (): Promise<ExportComboRes> => getLegacyShapedCombos(['DOWNLOAD_CD'])

/** FE 가 만든 엑셀의 다운로드 감사로그(ACT_TYP=EXPORT). 기록 실패는 5xx 로 온다. */
export const callToAddExportLog = (body: ExportLogReq) => request.post('/api/v1/access-logs/excel-download', body)

/**
 * FE 가 파싱한 엑셀 업로드의 감사로그(ACT_TYP=IMPORT).
 * 실패는 삼킨다 — 기록 실패를 업로드 실패로 보지 않고, 멱등키가 없어 재시도하면 행이 중복된다.
 */
export const callToAddImportLog = (body: ImportLogReq): void => {
  request.post('/api/v1/access-logs/excel-upload', body).catch(() => undefined)
}
